<template>
  <div class=" jCoTPh Personal-Center">
    <div class="sc-bwzfXH fNojfq" @click="$router.push('./Home')">
      <img draggable="false" src="../assets/logo.png" />
    </div>
    <div></div>
    <div class=" jofBxZ">
      <!-- 手机端 -->
      <main class="sc-cpmLhU ZAAcp">
        <div class="sc-jhAzac ceaCXY">
          <nav class="sc-laTMn hRtlIm">
            <div class="sc-jHZirH fYIPfZ">
              <CenterNavSun></CenterNavSun>
              <!-- <ul class="sc-aewfc lhblLm" id="nav-account">
                    <li class="sc-iIHjhz iRXnRJ"><a class="sc-dKEPtC cTUhRO" color="#222" href="/">Mein Account</a></li>
                    <li class="sc-iIHjhz iRXnRJ"><a class="sc-dKEPtC cTUhRO" color="#222" href="/security">Sicherheit</a>
                    </li>
                    <li class="sc-iIHjhz iRXnRJ"><a class="sc-dKEPtC cTUhRO" color="#222" href="/subscription">Abonnement
                        &amp; Bezahlung</a></li>
                    <li class="sc-iIHjhz iRXnRJ"><a class="sc-dKEPtC cTUhRO" color="#222"
                        href="/order-tracking">Vorbestellung (,)</a></li>
                    <li class="sc-iIHjhz iRXnRJ"><a class="sc-dKEPtC cTUhRO" color="#222" href="/apps">Anwendungen</a>
                    </li>
                    <li class="sc-iIHjhz iRXnRJ"><a class="sc-dKEPtC cTUhRO" color="#222" href="/share">Freunde werben</a>
                    </li>
                    <li class="sc-iIHjhz iRXnRJ"><a class="sc-dKEPtC cTUhRO" color="#222" href="/promo">Promoaktionen</a>
                    </li>
                    <li class="sc-iIHjhz iRXnRJ"><a class="sc-dKEPtC cTUhRO" color="#222" href="/support">Hilfe-Center</a>
                    </li>
                    <li class="sc-iIHjhz iRXnRJ"><button class="sc-dvpmds jKBcuJ"><span
                          class="sc-dBAPYN cnjqmx"></span>Ausloggen</button></li>
                  </ul> -->
            </div>
          </nav>
        </div>
      </main>
      <!-- 手机端结束 -->
    </div>
  </div>
</template>
<script>
import CenterNavSun from '@/components/CenterNavSun'
export default {
  components: {CenterNavSun},
  metaInfo: {
    title:'云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content:'海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content:'海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {

    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/CenterNav.vue